import React from "react";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import AddOutreachForm from "../../../Forms/AddOutreachForm";

const AddOutReach = () => {
  const { t } = useTranslation();
  return (
    <div>
      <MetaHead title={t("add-outreach")} />
      <AddOutreachForm />
    </div>
  );
};

export default AddOutReach;
